import React, { useState, useRef } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Components/Home";
import Vacancy from "./Components/Vacancy";
import Navbar from "./Components/Navbar";
import './App.css';

const App = () => {
  const [vacanciesCount, setVacanciesCount] = useState(0);

  // Refs for different sections
  const homeRef = useRef(null);
  const servicesRef = useRef(null);
  const productsRef = useRef(null);
  const clientsRef = useRef(null);
  const teamRef = useRef(null);
  const footerRef = useRef(null);

  // Create the Navbar instance
  const navbar = (
    <Navbar
      teamRef={teamRef}
      homeRef={homeRef}
      servicesRef={servicesRef}
      productsRef={productsRef}
      clientsRef={clientsRef}
      vacanciesCount={vacanciesCount}
      footerRef={footerRef}
    />
  );

  return (
    <Router>
      <div
        style={{
          // margin: '0 auto',
          width: '100%',
          // padding: '0 20px',
        }}
      >
        {navbar}
        <Routes>
          <Route
            path="/"
            exact
            element={
              <Home
                teamRef={teamRef}

                setVacanciesCount={setVacanciesCount}
                homeRef={homeRef}
                servicesRef={servicesRef}
                productsRef={productsRef}
                clientsRef={clientsRef}
                heroWrapperRef={useRef(null)}
                footerRef={footerRef}
              />
            }
          />
          {/* <Route
            path="/vacancy"
            element={<Vacancy setVacanciesCount={setVacanciesCount} />}
          /> */}
        </Routes>
      </div>
    </Router>
  );
};

export default App;